import React from "react";
import Sidebar from "../components/UserSidebar";
import ProfileHeader from "../components/ProfileHeader";
import AddComplaint from "../components/AddComplaint";

const Complaint = () => {
  // ✅ Get logged-in user from per-tab sessionStorage first, fallback to localStorage
  let username = "guest"; // default guest

  const sessionStored = sessionStorage.getItem("currentUser");
  if (sessionStored) {
    try {
      const userData = JSON.parse(sessionStored);
      if (userData && userData.role === "user" && userData.username) {
        username = userData.username;
      }
    } catch (err) {
      // fallthrough
    }
  } else {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        if (userData && userData.username) {
          username = userData.username;
        }
      } catch (err) {
        username = "guest";
      }
    }
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <ProfileHeader />

        <div style={{ padding: "20px", flex: 1 }}>
          {/* ✅ Pass usernameProp to AddComplaint */}
          <AddComplaint usernameProp={username} />
        </div>
      </div>
    </div>
  );
};

export default Complaint;
